import React from "react";
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
// @ts-ignore
import {faChevronRight, faChevronLeft} from "@awesome.me/kit-b8aac00bfe/icons/classic/solid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ScrollBar from "../../shared/ui/ScrollBar";
import CustomButton from "../../shared/ui/CustomButton";
import NotificationsIcon from "../../features/notifications/components/NotificationsIcon";
import Menu from "./Menu";
import BrioLogoFooter from "./BrioLogoFooter";
import TenantInfo from "./TenantInfo";
import UserInfo from "./UserInfo";
import {useAuth} from "../../hooks/useAuth";
import {Link} from "react-router-dom";
import NotificationsSwitch from "../../features/userProfile/components/NotificationsSwitch";

const openedMixin = (theme: Theme): CSSObject => ({
    // width: drawerWidth,
    [theme.breakpoints.up('lg')]: {
        width: 370, // LG
    },
    [theme.breakpoints.up('xl')]: {
        width: 410, // XL
    },
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    // width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('lg')]: {
        width: `calc(${theme.spacing(6.5)} + 1px)`,
    },
    [theme.breakpoints.up('xl')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 0,
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        // width: drawerWidth,
        [theme.breakpoints.up('lg')]: {
            width: 370, // LG
        },
        [theme.breakpoints.up('xl')]: {
            width: 410, // XL
        },
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': {
                ...openedMixin(theme),
                borderRadius: 0,
                [theme.breakpoints.up('lg')]: {
                    paddingRight: theme.spacing(1.5),
                    width: 370,
                },
                [theme.breakpoints.up('xl')]: {
                    paddingRight: theme.spacing(3),
                    width: 410,
                },
                backgroundColor: theme.palette.extra.sidebar,
            },
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': {
                ...closedMixin(theme),
                borderRadius: 0,
                // paddingRight: theme.spacing(1),
                backgroundColor: theme.palette.extra.sidebar,
            },
        }),
    }),
);
const SidebarMini = ({open, handleDrawerToggle} : {open: boolean, handleDrawerToggle: any}) => {
    const {user} = useAuth();

    return (
        <Drawer variant="permanent" open={open}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100dvh",
                }}
            >
                <DrawerHeader>
                    <Box
                         sx={{
                             width: "100%",
                             display: "flex",
                             justifyContent: open ? "space-between" : "center",
                             alignItems: "center",
                             marginTop: open ? 3 : 4,
                             marginBottom: 3,
                         }}
                    >
                        {open && <TenantInfo/>}
                        <CustomButton
                            buttonType="icon"
                            submit={true}
                            bgcolor="light"
                            onClick={handleDrawerToggle}
                            icon={!open
                                ? <FontAwesomeIcon style={{fontSize: "1rem"}} icon={faChevronRight}/>
                                : <FontAwesomeIcon style={{fontSize: "1rem"}} icon={faChevronLeft}/>}
                        />
                    </Box>
                </DrawerHeader>

                {open ? (
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Box>
                            <Link to="/profil"><UserInfo/></Link>
                            <>
                                {user.tenantNotifications && !user.emailNotifications && user.position !== "principal" && (
                                    <Box ml={7.5} mt={-2}><NotificationsSwitch/></Box>
                                )}

                            </>
                        </Box>
                        <Box>
                            {user.tenantNotifications && (
                                <NotificationsIcon/>
                            )}
                        </Box>
                    </Box>

                ) : (
                    <Box sx={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 4,
                        marginTop: 1,
                    }}>
                        {user.tenantNotifications && (
                            <NotificationsIcon/>
                        )}
                    </Box>
                )}

                {/* Scrollable menu area */}
                <Box pr={{lg: open ? 0 : 0.5, xl: open ? 0.5 : 1}} sx={{ flex: 1, overflow: "hidden" }}>
                    <ScrollBar
                        style={{ height: "100%", maxHeight: "100%", width: "100%" }}
                        forceVisible="x"
                        autoHide={false}
                    >
                        <Box>
                            <Menu direction="vertical" open={open} />
                        </Box>
                    </ScrollBar>
                </Box>

                <Box sx={{ p: 2 }}>
                    <BrioLogoFooter open={open}/>
                </Box>
            </Box>
        </Drawer>
    )
}

export default SidebarMini;